<div
  class="c03-question-mark-modal"
  [ngClass]="{ 'is-active': isOpen }"
  [cdkTrapFocus]="isOpen"
  (keydown)="keyDown($event)"
>
  <button
    #questionModalButtonRef
    (click)="onButtonMenuClick($event)"
    class="question-modal-toggle"
    [disabled]="isOpen"
    [attr.aria-label]="copy[jsonKey.MORE_INFO_ARIA_LABEL]"
  >
    <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 66 66">
      <path
        d="M31.1 33.6c1.1-2 3.2-3.1 4.4-4.9 1.3-1.8.6-5.2-3.1-5.2-2.4 0-3.6 1.8-4.1 3.3l-3.7-1.5c1-3 3.7-5.6 7.7-5.6 3.3 0 5.6 1.5 6.8 3.4 1 1.6 1.6 4.7 0 6.9-1.7 2.5-3.3 3.3-4.2 4.9-.4.7-.5 1.1-.5 3.2h-4.1c.1-1.1 0-2.9.8-4.5zm4.2 10.2c0 1.6-1.3 2.8-2.8 2.8-1.6 0-2.8-1.3-2.8-2.8 0-1.6 1.3-2.8 2.8-2.8 1.5-.1 2.8 1.2 2.8 2.8z"
      />
    </svg>
  </button>
  <div
    class="modal-content"
    role="dialog"
    aria-describedby="dialogTitle"
    aria-labelledby="moreInfoDialog"
    #modalContentRef
  >
    <button
      #questionModalButtonRef
      [attr.aria-label]="copy[jsonKey.CLOSE_BUTTON_ARIA_LABEL]"
      data-animation="c03-modal-content"
      class="close-modal-toggle"
      (click)="onButtonMenuClick($event)"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15" fill="currentColor">
        <path d="M15 1.5 13.5 0l-6 6-6-6L0 1.5l6 6-6 6L1.5 15l6-6 6 6 1.5-1.5-6-6 6-6z" />
      </svg>
    </button>
    <div class="text-container">
      <p data-animation="c03-modal-content" class="eyebrow" id="moreInfoDialog">
        {{ copy[jsonKey.MORE_INFO_EYEBROW] }}
      </p>
      <h2 data-animation="c03-modal-content" class="title" id="dialogTitle">
        {{ copy[featureMoreInfoTitleKey] }}
      </h2>
      <p
        data-animation="c03-modal-content"
        class="paragraph"
        [innerHTML]="copy[featureMoreInfoMainCopyKey]"
      ></p>
      <p
        data-animation="c03-modal-content"
        class="legal-footer"
        [innerHTML]="copy[featureMoreInfoLegalFooterKey]"
      ></p>
    </div>
  </div>
</div>
